import React from 'react';

const CONTACT_EMAIL = 'vasilii.vazhesov@gmail.com';
const BRAND_NAME = 'All Completed';
const DEFAULT_LINKS = [
  {
    label: 'Docs',
    href: 'https://github.com/all-completed/tuning-proxy/blob/main/docs/API.md'
  },
  {
    label: 'GitHub',
    href: 'https://github.com/all-completed/tuning-proxy'
  },
  {
    label: 'Support',
    href: `mailto:${CONTACT_EMAIL}`
  }
];

function Footer({ compact, style, links = DEFAULT_LINKS }) {
  const year = new Date().getFullYear();
  const baseStyle = {
    color: 'var(--rs-text-secondary)',
    borderTop: '1px solid var(--rs-border-secondary)',
    ...style
  };

  return (
    <footer style={baseStyle}>
      <div
        style={{
          maxWidth: 1100,
          margin: '0 auto',
          padding: compact ? '14px 16px' : '22px 16px',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
          fontSize: 13,
          lineHeight: 1.6
        }}
      >
        <div>© {year} {BRAND_NAME}</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 14 }}>
          {links.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target={link.href.startsWith('http') ? '_blank' : undefined}
              rel={link.href.startsWith('http') ? 'noreferrer' : undefined}
              style={{ color: 'inherit', textDecoration: 'none' }}
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
